import React from 'react';
import { connect } from 'react-redux';
import {
  getCustomerCompanies,
  getCustomerCompaniesSearch,
  getCustomerCompaniesSearchClear,
} from '../../common/redux/actions/profileFieldsActions';

const customerCompaniesConnect = (Component, filters) => {
  return connect(
    state => ({
      customerCompanies:
        state.Common.ProfileFields.customerCompanies &&
        state.Common.ProfileFields.customerCompanies.value
          ? state.Common.ProfileFields.customerCompanies.search
          : state.Common.ProfileFields.customerCompanies.all,
      isLoading:
        state.Common.ProfileFields.customerCompanies &&
        state.Common.ProfileFields.customerCompanies.isLoading,
    }),
    {
      getCustomerCompanies,
      getCustomerCompaniesSearch,
      getCustomerCompaniesSearchClear,
    }
  )(
    class extends React.PureComponent {
      componentDidMount() {
        if (!this.props.customerCompanies) {
          this.props.getCustomerCompanies();
        }
      }
      render() {
        return <Component {...this.props} />;
      }
    }
  );
};

export default customerCompaniesConnect;